import { render, staticRenderFns } from "./SideNavLayout.vue?vue&type=template&id=6d366b2a&scoped=true"
import script from "./SideNavLayout.vue?vue&type=script&lang=js"
export * from "./SideNavLayout.vue?vue&type=script&lang=js"
import style0 from "./SideNavLayout.vue?vue&type=style&index=0&id=6d366b2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d366b2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d366b2a')) {
      api.createRecord('6d366b2a', component.options)
    } else {
      api.reload('6d366b2a', component.options)
    }
    module.hot.accept("./SideNavLayout.vue?vue&type=template&id=6d366b2a&scoped=true", function () {
      api.rerender('6d366b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/SideNavLayout.vue"
export default component.exports